module.exports = __webpack_public_path__ + "static/media/GoogleApsScript.b4be90e6.png";